/*
 * Produkt-Info-Tabs
 * - Öffner-Buttons (.product-info-tabs__btn) öffnen das zugehörige <modal-dialog>
 *   (Mechanik aus global.js) und aktivieren den passenden Tab.
 * - Tabs innerhalb des Modals (.product-info-modal__tab) schalten die Panels um.
 */
(function () {
  function activate(modal, key) {
    if (!modal || !key) return;
    modal.querySelectorAll('[data-info-panel]').forEach(function (el) {
      var on = el.getAttribute('data-info-panel') === key;
      if (el.getAttribute('role') === 'tab') {
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
      } else {
        el.classList.toggle('is-active', on);
        if (on) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      }
    });
  }

  function init() {
    // Tab-Wechsel innerhalb des Modals
    document.querySelectorAll('.product-info-modal').forEach(function (modal) {
      modal.querySelectorAll('[role="tab"][data-info-panel]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(modal, tab.getAttribute('data-info-panel'));
        });
      });
    });

    // Öffner-Leiste: Modal öffnen + gewünschten Tab aktivieren
    document.querySelectorAll('.product-info-tabs').forEach(function (bar) {
      var modal = document.getElementById(bar.getAttribute('data-modal-id'));
      bar.querySelectorAll('[data-info-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!modal) return;
          activate(modal, btn.getAttribute('data-info-tab'));
          if (typeof modal.show === 'function') {
            modal.show(btn);
          } else {
            modal.setAttribute('open', '');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
